<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "primary-high", size: "md" });

const colorClass = computed((): string => `stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 18 18">
    <path
      d="M4.8578 11.778V16.1846C4.8578 16.6713 5.25238 17.0659 5.73912 17.0659H12.7897C13.2764 17.0659 13.671 16.6713 13.671 16.1846V11.778M4.8578 11.778H13.671M4.8578 11.778V13.5406H2.21384C1.7271 13.5406 1.33252 13.146 1.33252 12.6593V5.60874C1.33252 5.12201 1.7271 4.72743 2.21384 4.72743H16.3149C16.8017 4.72743 17.1963 5.12201 17.1963 5.60874V12.6593C17.1963 13.146 16.8017 13.5406 16.3149 13.5406H13.671V11.778M5.73912 8.2527H4.8578M5.73912 1.20215H12.7897C13.2764 1.20215 13.671 1.59673 13.671 2.08347V3.84611C13.671 3.88887 13.671 3.93092 13.671 3.97206C13.671 4.38927 13.3328 4.72743 12.9156 4.72743H5.61321C5.19601 4.72743 4.8578 4.38927 4.8578 3.97206C4.8578 3.93092 4.8578 3.88887 4.8578 3.84611V2.08347C4.8578 1.59673 5.25238 1.20215 5.73912 1.20215Z"
      :class="colorClass"
      stroke-width="1.51083"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
